import { Icon } from '@photosi/rn-components/icon/Icon';
import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import { View } from 'react-native';
import { neutrals } from 'src/theme/colors';
import { styles } from './N8nChatButton.styles';
import { LinearGradient } from 'expo-linear-gradient';
import amplitude from 'src/_shared/amplitude';
import { AnalyticsEvents } from 'src/_shared/analyticsEvents';
import { TestIDs } from 'src/constants/testIDs.constants';
import { TChatButtonProps } from '../ChatButton.types';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/contexts/StoreContext';
import Button from '@photosi/rn-components/buttons/button/Button';
import { FocusGroups } from '@photosi/rn-components/focus-provider/FocusProvider.constants';
import { useState } from 'react';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';
import { Gradients } from 'src/theme-v2/colors';

export const N8nChatButton = observer(({ newGraphic, focusGroup, focusOrder }: TChatButtonProps) => {
  const {
    i18n,
    user: { isRetailer },
  } = useStore();
  const [isOpened, setIsOpened] = useState(false);

  const { isDesktop } = useResponsiveScreen();

  const onPress = async () => {
    amplitude.trackEvent(AnalyticsEvents.personalize.supportClick);
    (document.getElementsByClassName('chat-window-toggle')[0] as HTMLElement).click();
    setIsOpened(toggle => !toggle);
  };

  if (!newGraphic)
    return (
      <Button
        testID={TestIDs.N8N_CHAT_BUTTON}
        style={[styles.buttonChatOld, !isRetailer && styles.consumerAlternateColor]}
        onPress={onPress}
        accessible={true}
        accessibilityLabel={i18n.t('general:chat')}
        accessibilityRole="button"
        focusId={TestIDs.N8N_CHAT_BUTTON}
        focusGroup={focusGroup ?? FocusGroups.BOTTOM_BAR}
        focusOrder={focusOrder ?? 0}
      >
        {() => (
          <View style={styles.iconChatOld}>
            <Icon name={isOpened ? ICON_NAMES.ChatOldClose : ICON_NAMES.ChatOld} />
          </View>
        )}
      </Button>
    );

  return (
    <Button
      testID={TestIDs.N8N_CHAT_BUTTON}
      style={styles.buttonChat}
      innerStyle={isDesktop ? styles.buttonChatInner : styles.buttonChatInnerMobile}
      onPress={onPress}
      accessible={true}
      accessibilityLabel={i18n.t('general:chat')}
      accessibilityRole="button"
      focusId={TestIDs.N8N_CHAT_BUTTON}
      focusOrder={focusOrder ?? 4}
      focusGroup={focusGroup ?? FocusGroups.HEADER}
      focusStyle={styles.buttonFocus}
    >
      {() => (
        <LinearGradient
          colors={Gradients.AiGradient}
          style={isDesktop ? styles.buttonChatGradient : styles.buttonChatGradientMobile}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 0.3 }}
          pointerEvents="none"
        >
          <View style={styles.iconChat}>
            <Icon
              name={ICON_NAMES.ChatAI}
              color={neutrals.white}
              width={isDesktop ? 24 : 16}
              height={isDesktop ? 24 : 16}
            />
          </View>
        </LinearGradient>
      )}
    </Button>
  );
});
